export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";